export default {
    
    //*AUTH */
    SET_LOGIN : 'SET_LOGIN',
    SET_TOKEN : 'SET_TOKEN',
    SET_REFRESH_TOKEN : 'SET_REFRESH_TOKEN ',
    SET_EXPIRED : 'SET_EXPIRED',
    SET_USUARIO: 'SET_USUARIO',
    SET_PRINCIPAL :'SET_PRINCIPAL',
    SET_SISTEMA_PRINCIPAL: 'SET_SISTEMA_PRINCIPAL',
    // AUTH DEPENDENCIA
    SET_DEPENDENCIA: 'SET_DEPENDENCIA',

    //*CATALOG */
    SET_CATALOGO : 'SET_CATALOGO',

     /*Usuarios */
     SET_USUARIOSDEPS :'SET_USUARIOSDEPS',

}
